module.exports = __webpack_public_path__ + "static/img/hello.15227611.png";